import { ReactNodeProps } from '@/types/reactNodeProps'
import twMerge from '@/utils/classes/twMerge'
import getColor from '@/utils/color/getColor'

export interface Props extends ReactNodeProps {
  color?: string
  className?: string
}

export default function Tag(props: Props) {
  return (
    <div
      className={twMerge(
        `rounded-[8px] bg-${props.color} text-center px-3 py-1 h-fit`,
        props.className,
      )}
    >
      {props.children}
    </div>
  )
}
